export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_INVALID = 'AUTH_LOGIN_INVALID';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR';
// ----------------------------------------------------------------------------
export const AUTH_SET_LOGGED_IN_USER = 'AUTH_SET_LOGGED_IN_USER';
// ----------------------------------------------------------------------------
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';
export const AUTH_LOG_OUT_SUCCESS = 'AUTH_LOG_OUT_SUCCESS';
